import { useMutation, UseMutationOptions } from 'react-query';

import type { BuildDocFiltersWithNLResponseDto } from '../../../../backend/src/case/doc/dto/build-doc-filters-with-nl.dto.js';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface BuildDocFiltersWithNLParams {
  caseId: string;
  query: string;
}

export const useBuildDocFiltersWithNL = (
  options?: UseMutationOptions<BuildDocFiltersWithNLResponseDto, Error, BuildDocFiltersWithNLParams>,
) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation({
    mutationFn: async ({ caseId, query }: BuildDocFiltersWithNLParams) => {
      const response = await fetch(
        `${APIBaseChronos}/api/case/${caseId}/docs/build-filters-nl`,
        getFetchConfig({
          method: FetchMethod.POST,
          data: { query },
        }),
      );

      if (!response.ok) {
        throw new Error('Failed to build document filters with natural language');
      }

      return response.json();
    },
    ...options,
  });
};
